const COOKIE = 'uwf_consent';

export function currentConsent(): 'all' | 'necessary' | null {
    const match = document.cookie.split('; ').find((c) => c.startsWith(`${COOKIE}=`));
    const value = match?.split('=')[1];
    return value === 'all' || value === 'necessary' ? value : null;
}

function store(choice: 'all' | 'necessary'): void {
    const oneYear = 60 * 60 * 24 * 365;
    document.cookie = `${COOKIE}=${choice}; max-age=${oneYear}; path=/; SameSite=Lax`;
}

function loadGa4(id: string): void {
    if (!id) return;
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);
    const w = window as unknown as { dataLayer: unknown[]; gtag?: (...args: unknown[]) => void };
    w.dataLayer = w.dataLayer || [];
    w.gtag = function (...args: unknown[]) { w.dataLayer.push(args); };
    w.gtag('js', new Date());
    w.gtag('config', id, { anonymize_ip: true });
}

export function initConsent(banner: HTMLElement, ga4Id: string): void {
    const choice = currentConsent();
    if (choice === 'all') loadGa4(ga4Id);
    if (choice === null) {
        banner.hidden = false;
        document.body.classList.add('has-consent-banner');
    }

    banner.querySelectorAll<HTMLButtonElement>('[data-consent]').forEach((btn) => {
        btn.addEventListener('click', () => {
            const value = btn.dataset.consent === 'all' ? 'all' : 'necessary';
            store(value);
            banner.hidden = true;
            document.body.classList.remove('has-consent-banner');
            if (value === 'all') loadGa4(ga4Id);
        });
    });
}
